import React from 'react';
import CalendarView from './CalendarView';

const StockAnalysisList = () => {
    return (
        <CalendarView />
    );
};

export default StockAnalysisList;
